export var LOADING_INDICATOR_TESTID = 'LOADING_INDICTOR';
export var LOADING_INDICATOR_ARIA_LABEL = 'Page is being loaded...';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/modules/LoadingIndicator/constants.js
// module id = 4175
// module chunks = 11